import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { ProductSelector } from "@/components/ProductSelector";

export function InventoryFilter({ onFilterChange, products }) {
  const [selectedProductId, setSelectedProductId] = useState(null);

  const clearFilter = () => {
    setSelectedProductId(null);
    onFilterChange(null);
  };

  return (
    <div className="relative">
      {/* Selector por producto (con temporada y etiquetas) */}
      <div className="mt-1">
        <div className="text-xs font-semibold text-gray-600 mb-1">Selector avanzado</div>
        <ProductSelector
          value={selectedProductId}
          onSelect={(productId) => {
            setSelectedProductId(productId);
            if (productId) {
              const product = products.find(p => p.id === productId);
              onFilterChange({ productId, type: 'product' });
            } else {
              onFilterChange(null);
            }
          }}
          onApplyFilters={({ productIds }) => {
            try {
              if (Array.isArray(productIds) && productIds.length > 0) {
                onFilterChange({ type: 'products', productIds });
              } else {
                onFilterChange(null);
              }
            } catch (_) {}
          }}
        />
      </div>

      {selectedProductId && (
        <div className="mt-2 p-2 bg-blue-50 rounded-md">
          <div className="flex justify-between items-start gap-3">
            <div className="flex gap-3">
              {(() => {
                const product = products.find(p => p.id === selectedProductId);
                return (
                  <>
                    {product?.images?.[product.main_image_index] && (
                      <div className="w-12 h-12 flex-shrink-0 rounded-md overflow-hidden">
                        <img
                          src={product.images[product.main_image_index]}
                          alt={product.description}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    )}
                    <div>
                      <div className="font-medium text-sm">{product?.code}</div>
                      <div className="text-xs text-gray-600">{product?.description}</div>
                    </div>
                  </>
                );
              })()}
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={clearFilter}
              className="text-blue-600 hover:text-blue-800"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
} 